import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {DeviceService} from "../services/sim-services/device.service";
import {DeviceActivityType} from "@models";

export const displayGuard: CanActivateFn = async () => {
	const router = inject(Router);
	const deviceService = inject(DeviceService);

	const device = deviceService.device;

	if (device().autoLoginCapability.type !== DeviceActivityType.Display) {
		console.error("Device does not have display capability");
		return await router.navigate([""]);
	}

	return true;
};
